module.exports = __webpack_public_path__ + "static/user-thumbnail-1-a9257eea2cf931c378632b1315913020.jpg";